import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import { apiResponse } from "../../utils/apiResponse";

const Non_WidgetDetailModal = ({ showModal, closeModal, non_widgetname }) => {
    return (
        <>
            <Modal
                className="DeviceDetailModalMain"
                fullscreen={true}
                centered
                show={showModal}
                onHide={closeModal}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {non_widgetname} Guidance
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {non_widgetname && (
                        <>
                            <iframe key={"1"} title={non_widgetname} src={`${API_URL.BASE_API_URL.ADMINAPI.replace("api/v1/", "wwwroot/widget/doc_") + non_widgetname}.pdf`} frameborder="0" style={{ width: "100%", height: "99%" }}></iframe>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Non_WidgetDetailModal;